import React from 'react';
import { MetricsProvider } from '@zocdoc/frontend-metrics';

import FooterWithMetrics from './Footer';

export default function (props) {
    return (
        <MetricsProvider sendMetric={() => {}}>
            <FooterWithMetrics {...props} />
        </MetricsProvider>
    );
}

export { FooterWithMetrics };
